import { useQueryClient as e } from "@tanstack/react-query";
//#region src/hooks/useQueryClient.ts
function t() {
	return e();
}
//#endregion
export { t as useQueryClient };
